var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function MessagesWS() {
  var self; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;

  self.allLanguages = ko.observableArray([]);
  self.allLanguageNames = ko.observableArray([]);
  self.bundle = ko.observable(null);
  self.bundles = [];
  self.json = null;
  self.localesParam = ko.observable('');
  self.name = 'MessagesWS';				// Convenience name for debugging
  self.phoneMask = ko.observable(null);


	/**
	* This computed observable returns the URL of the service endpoint
	*
	* @method serviceURL
	* @returns {String}
	*/
  self.serviceURL = ko.computed(function () {
    return '';
  });


	/**
	* This computed observable returns the locale of the currently selected bundle
	*
	* @method activeLocale
	* @returns {String|Null} The locale token of the current bundle
	*/
  self.activeLocale = ko.computed(function () {
    if (self.bundle() != null) {
      return self.bundle().locale;
    }
    return null;
  });


	/**
	* Override of abstract method. Allows for the URL to be created at runtime
	*
	* @method doRequest
	* @param {Function} fCallback
	* @returns none
	*/
  self.doRequest = function (fCallback, locId) {
    var endP = null;

    if (!locId && self.parent.allLocationIds().length > 0) {
      // Get a list of languages from the selected locations
      var langs = self.parent.selectedLocationIds().reduce(function (arr, id) {
        var loc = self.parent.locationsWS.getLocationById(id);

        if (loc && Array.isArray(loc)) {
          loc.language.forEach(function (lang) {
            if (!arr.includes(lang)) {
              arr.push(lang);
            }
          });
        }

        return arr;
      }, []);

      endP = '/qless/api/v1/messages/merchant/location/' + self.parent.allLocationIds()[0];

      if (langs.length > 0) {
        endP += '?locale=' + langs.join(',');
      }
      else {
        endP += '?locale=' + self.parent.userLang();
      }
    }
    else if (locId) {
      endP = '/qless/api/v1/messages/merchant/location/' + locId;
    }

    if (endP) {
      // Generate a new Service URL
      self.serviceURL = ko.computed(function () {
        return endP;
      });

      AbstractWS.prototype.doRequest.call(self, fCallback);
    }
  };


	/**
	* Method to retrieve text value of the provided key from the current bundle
	*
	* @method get
	* @param {String} sKey Token to use to find the text value from the bundle
	* @param {Boolean} bStripHTML Unless passed as false, HTML entities will be removed
	* @param {Array} aTokens Array of token replacement strings
	* @returns {String}
	*/
  self.get = function (sKey, bStripHTML, locale) {
    var i = 0,						// Standard increment
      aBundle = self.bundle(),	// Currently selected bundle
      oMessage = null,			// XML node corresponding to the key
      sVal = '',					// return value
      tokens = null,				// collection of matched tokens ({0}) found in the string
      tokenString;				// Replacement message

    if (locale) {
      self.bundles.forEach(function (bndl) {
        if (bndl.locale.toLowerCase() == locale.toLowerCase()) {
          aBundle = bndl;
        }
      });
    }

    // If there is a bundle, else return an empty string
    if (aBundle) {

      var nMessages = aBundle.m;

      // Loop over the bundle's messages, looking for a node
      // with a corresponding key. If one if found, return the
      // string value, otherwise return an empty string
      for (i = 0; i < nMessages.length; i++) {
        // reference to the current message node
        oMessage = nMessages[i];

        // If the key if sound in the node
        if (oMessage.n === sKey) {
          // If the node doesn't have a text value, disregard
          if (oMessage.text === undefined) {
            break;
          }

          // Pull the text value into a return variable so
          // it can be manipulated
          sVal = oMessage.text;

          // Unless told not to, remove any HTML formatting
          if (sVal && bStripHTML !== false) {
            sVal = sVal && String(sVal).replace(/(<([^>]+)>)/ig, '');
          }


          // handle any token replacements
          tokens = sVal && String(sVal).match(/{[0-9a-zA-Z\.]+}/g);

          if (tokens) {
            for (j = 0; j < tokens.length; j++) {
              tokenString = self.get(tokens[j].replace('{', '').replace('}', ''));

              if (tokenString != '') {
                sVal = sVal.replace(tokens[j], tokenString);
              }
            }
          }

          //sVal = Strings.replaceNewlines( sVal );

          return sVal;
        }
      }

      // No matching text string was found; return an empty string
      return '';
    }

    // No bundle found; return an empty string
    return '';
  };


	/**
	* Sets the current bundle to the specified language string. If the language
	* string was not found, try to load the defaultLocale bundle. If a bundle
	* could still not be found, just load the first language bundle instead.
	*
	* @method setLocale
	* @param {String} sLang language locale to find a bundle of
	* @returns {MessagesWS} Returns the object as chainable, for best practice
	*/
  self.setLocale = function (sLang) {
    var bundle = null,		// Instance of a message bundle
      bFound = false,		// Whether a matching bundle was found
      i = 0;				// Standard increment

    // If the language locale was not specified, don't bother
    if (sLang == null) {
      return;
    }

    // Start by trying to set the bundle to the requested bundle
    self.bundles.forEach(function (bundle) {
      var langParts = sLang.toLowerCase().split('_');
      var bundleParts = bundle.locale.toLowerCase().split('_');

      if (bundle.locale.toLowerCase() == sLang.toLowerCase()) {
        bFound = true;
        self.bundle(bundle);
      }
      else if (!bFound && langParts[0] == bundleParts[0]) {
        bFound = true;
        self.bundle(bundle);
      }
    });

    // If the requested bundle could not be found and the default language
    // bundle could not be found (accounting for logic error in the VM
    // defaultLocale() function), just set the bundle to the first bundle
    if (!bFound) {
      self.bundle(self.bundles[0]);
    }

    // Return self (MessagesWS) to be chainable, for best practice
    return self;
  };


	/**
	* This method processes the data returned from the service
	*
	* @method processData
	* @param {XMLString} xmlData XML data returned from the service
	* @returns {MessagesWS} Returns the object as chainable, for best practice
	*/
  self.processData = function (xmlData) {
    var locale = 'en';

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);
    var json = xmlToJson.parse(xmlData);

    if (!Array.isArray(json.bundles.bundle)) {
      self.bundles = [json.bundles.bundle];
    }
    else {
      self.bundles = json.bundles.bundle;
    }

    // Sets the initial bundle
    self.bundles.forEach(function (bndl) {
      if (self.parent.userLang && self.parent.userLang() && self.parent.userLang().toLowerCase() === bndl.locale.toLowerCase()) {
        locale = bndl.locale;
      }
    });

    self.setLocale(locale);

    // Set the phoneMask
    self.phoneMask(self.get('phone.mask') || null);

    // Return self (MessagesWS) to be chainable, for best practice
    return self;

  };

  // Return self (MessagesWS)
  return self;
};


/**
* Sets an element's innerHTML to the localized token string
*
* @method messageCustomBind
* @param
* @returns none
*/
function messageCustomBind(element, valueAccessor, allBindingsAccessor, viewModel) {
  var value = valueAccessor();

  var getMessage = function (keys) {
    if (!Array.isArray(keys)) {
      keys = [keys];
    }

    if (keys.length <= 0) {
      return "";
    }

    var key = keys.shift();
    var message = vm.messagesWS.get(key, true);
    return (message) ? message : getMessage(keys);
  };

  try {
    element.innerHTML = getMessage(value);
  }
  catch (e) {
    window.Sentry && window.Sentry.captureException(e);
  }
}



/**
* Sets an element's title attribute to the localized token string
*
* @method messageCustomHint
* @param
* @returns none
*/
function messageCustomHint(element, valueAccessor, allBindingsAccessor, viewModel) {
  var data = valueAccessor();

  try {
    var val = vm.messagesWS.get(data, true);
    element.setAttribute('title', val);
  }
  catch (e) {
    window.Sentry && window.Sentry.captureException(e);
  }
}

// Create a Knockout binding handler to make it easier to pull messages directly from
// the HTML files. The data-bind will look like: message: 'key'
ko.bindingHandlers.message = {
  init: messageCustomBind,
  update: messageCustomBind
};



// Create a Knockout binding handler to make it easier to pull messages directly from
// the HTML files as title attributes on elements
// The data-bind will look like: hint: 'key'
ko.bindingHandlers.hint = {
  init: messageCustomHint,
  update: messageCustomHint
};

MessagesWS.prototype = AbstractWS.prototype;
MessagesWS.prototype.constructor = AbstractWS;

module.exports = MessagesWS
